export default function SectionHeader({ kicker, title, subtitle, align = "left", cta }) {
  return (
    <div className={`mb-8 md:mb-10 ${align === "center" ? "text-center mx-auto max-w-2xl" : ""}`}>
      {kicker && (
        <div data-testid="section-kicker" className="text-xs font-bold uppercase tracking-widest text-accent mb-3">{kicker}</div>
      )}
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-montserrat font-bold tracking-tight text-slate-900">{title}</h2>
      {subtitle && <p className="mt-3 text-base text-slate-600 max-w-2xl">{subtitle}</p>}
      <div className="mt-4 flex items-center justify-between gap-4">
        {cta}
      </div>
    </div>
  );
}
